export const HOME_ROUTE = '/';
export const AUTH_ROUTE = '/login';
export const ANNOUNCE_ROUTE = '/announce';
export const TABLE_ROUTE = '/table';
export const RESULT_ROUTE = '/result';
export const TABLE_ROUTE_7 = '/table7';
export const RESULT_ROUTE_7 = '/result7';
export const TABLE_ROUTE_8 = '/table8';
export const RESULT_ROUTE_8 = '/result8';
export const TABLE_ROUTE_6 = '/table6';
export const RESULT_ROUTE_6 = '/result6';
export const TABLE_ROUTE_5 = '/table5';
export const RESULT_ROUTE_5 = '/result5';
export const TABLE_ROUTE_4 = '/table4';
export const RESULT_ROUTE_4 = '/result4';
export const TABLE_ROUTE_3 = '/table3';
export const RESULT_ROUTE_3 = '/result3';
export const TABLE_ROUTE_2 = '/table2';
export const RESULT_ROUTE_2 = '/result2';
export const TABLE_ROUTE_1 = '/table1';
export const RESULT_ROUTE_1 = '/result1';